import React from 'react';
import { Alert, Button, Theme, Typography } from '@mui/material';
import { colorPalette } from '@qualifio/ui-commons';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import loginBackground from './login-background.png';
import qualifioLoyalty from './qualifio-loyalty.svg';
import { Loader } from '../../shared/layout/Loader';

const useStyles = makeStyles<Theme>(({ spacing }) => ({
  root: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    height: '100%',
    width: '100%',
    background: colorPalette.marine.main,
    color: 'white',
  },
  backgroundImage: {
    position: 'absolute',
    right: 0,
    bottom: 0,
  },
  logo: {
    marginBottom: 20,
  },
  container: {
    width: 370,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    color: 'white !important',
    '&:after': {
      backgroundColor: colorPalette.primary.main,
      content: "''",
      display: 'block',
      height: 2,
      margin: spacing(1.5, 'auto', 0),
      width: 60,
    },
  },
  text: {
    padding: '0px 56px 0px 56px',
  },
  alert: {
    marginTop: 10,
  },
}));

interface Props {
  error?: boolean;
  loading?: boolean;
  isLoggedOut?: boolean;
}

export function LoginScreen({ error, loading, isLoggedOut }: Props) {
  const classes = useStyles();
  const { t } = useTranslation();

  function login() {
    window.location.href = `${BASE_PATH}/api/auth/login`;
  }

  return (
    <div className={classes.root}>
      <img className={classes.backgroundImage} src={loginBackground} />
      <img className={classes.logo} src={qualifioLoyalty} />
      {loading ? (
        <Loader iconProps={{ size: '2x' }} />
      ) : (
        <div className={classes.container}>
          <Typography variant="h2" className={classes.title}>
            {t('auth.login-page.title')}
          </Typography>
          {error && (
            <Alert className={classes.alert} severity="warning">
              {t('auth.login.errors.authError')}
            </Alert>
          )}
          <p>
            {error
              ? t('auth.login-page.click-to-try-again')
              : t('auth.login-page.click-to-continue')}
          </p>

          <Button color="orange" onClick={login} id="login-button">
            Log in
          </Button>
        </div>
      )}
    </div>
  );
}
